import type { CreateProfessionInput } from '@idc-forms/schemas'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateProfessionV2Mutation } from '../hooks/use-profession-v2-mutations'
import { ProfessionForm } from './profession-form'

type ProfessionV2CreatePanelProps = {
  onDone?: () => void
}

/**
 * "Nueva profesión" contra la API v2, dentro del side panel.
 *
 * Reusa el `ProfessionForm` del v1 sin duplicarlo: el contrato de entrada v2
 * coincide campo a campo con `CreateProfessionInputSchema` (`name` + `active`) —
 * `isOther` nunca fue editable en ninguna de las dos versiones—. La única
 * diferencia del wire v2 es que el backend normaliza el nombre a MAYÚSCULAS, y eso
 * no cambia lo que el formulario pide.
 */
export function ProfessionV2CreatePanel({ onDone }: ProfessionV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateProfessionV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: CreateProfessionInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <ProfessionForm
      submitLabel="Crear profesión"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
